<template>
  <div class="etms-router-body">
    <div class="etms-router-search">
      <span class="etms-router-search-label fl">供应商名：</span>
      <el-input size="mini" v-model="search.SupplyName" placeholder="填写供应商名称搜索" class="etms-router-search-element el-width-200 fl"></el-input>
      <span class="etms-router-search-label fl">分类：</span>
      <el-select size="mini" placeholder="选择供应商分类搜索" v-model="search.ChannelSupplyType" class="etms-router-search-element el-width-200 fl">
        <el-option v-for="item in constant.supplyTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
      </el-select>
      <el-tooltip class="item" effect="dark" content="添加" placement="top">
        <el-button size="mini" @click="insertSupplier" class="etms-router-search-button fr" type="primary" icon="el-icon-plus"></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="查询" placement="top">
        <el-button size="mini" @click="searchSupplierPager" class="etms-router-search-button fr" type="primary" icon="el-icon-search"></el-button>
      </el-tooltip>
      <div class="clear"></div>
    </div>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="constant.pagesizes" :current-page="search.pageindex" :page-size="search.pagesize" :total="search.recordcount" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
    <el-table :data="supplylist" :border="true" height="90%" class="etms-router-list">
      <el-table-column label="序号" type="index" align="center"></el-table-column>
      <el-table-column label="分类" align="center" prop="channelSupplyType" :formatter="formatterSupplyType">
      </el-table-column>
      <el-table-column label="供应商代码" prop="channelSupplyCode" align="center"></el-table-column>
      <el-table-column label="供应商名" prop="channelSupplyName" align="center"></el-table-column>
      <el-table-column label="联系人" prop="contactName"></el-table-column>
      <el-table-column label="所在地" prop="contactRegion" :formatter="formatterRegion">
      </el-table-column>
      <el-table-column label="详细地址" prop="contactAddress"></el-table-column>
      <el-table-column label="联系电话">
        <template slot-scope="scope">
          {{scope.row.contactMobile}}/{{scope.row.contactPhone}}
        </template>
      </el-table-column>
      <el-table-column label="QQ" prop="contactQQ"></el-table-column>
      <el-table-column label="微信" prop="contactWechat"></el-table-column>
      <el-table-column label="邮箱" prop="contactEmail"></el-table-column>
      <el-table-column label="状态" prop="state"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" content="修改" placement="top">
            <el-button size="mini" type="primary" icon="el-icon-edit-outline" circle @click="editChannelSupply(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" content="删除" placement="top">
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="removeChannelSupply(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="dialogSupply.dialogtitle" :visible.sync="dialogSupply.dialogvisible" :modal-append-to-body="false" center class="el-form-half" width="750px">
      <el-tabs v-model="dialogSupply.activename">
        <el-tab-pane label="供应商信息" name="supplyinfo">
          <el-form :model="dialogSupply.form" :ref="dialogSupply.form.formname" :rules="dialogSupply.form.rules" label-width="120px" class="etms-dialog-form">
            <el-form-item label="分类：" prop="ChannelSupplyType">
              <el-select size="mini" placeholder="请选择分类" v-model="dialogSupply.form.ChannelSupplyType" class="el-width-200" @change="supplyTypeChange">
                <el-option v-for="item in constant.supplyTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="平台物流商：" v-show="dialogSupply.form.ChannelSupplyType===1" prop="PlatformEnterpriseId">
              <el-select size="mini" placeholder="请选择物流商" v-model="dialogSupply.form.PlatformEnterpriseId" class="el-width-200">
                <el-option v-for="item in enterpriselist" :key="item.id" :value="item.id" :label="item.enterpriseName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="供应商代码：" prop="ChannelSupplyCode">
              <el-input size="mini" placeholder="请填写供应商代码" v-model="dialogSupply.form.ChannelSupplyCode" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="供应商名称：" prop="ChannelSupplyName">
              <el-input size="mini" placeholder="请填写供应商名称" v-model="dialogSupply.form.ChannelSupplyName" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="地区：" prop="ContactRegion">
              <el-cascader size="mini" placeholder="请选择地区" :options="regionmodule.regions" v-model="dialogSupply.form.ContactRegion" filterable class="el-width-200"></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址：" prop="ContactAddress">
              <el-input size="mini" placeholder="请填写详细地址" v-model="dialogSupply.form.ContactAddress" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="联系人：" prop="ContactName">
              <el-input size="mini" placeholder="请填写联系人" v-model="dialogSupply.form.ContactName" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="手机号码：" prop="ContactMobile">
              <el-input size="mini" placeholder="请填写手机号码" v-model="dialogSupply.form.ContactMobile" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="电话号码：" prop="ContactPhone">
              <el-input size="mini" placeholder="请填写电话号码" v-model="dialogSupply.form.ContactPhone" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="QQ：" prop="ContactQQ">
              <el-input size="mini" placeholder="请填写QQ" v-model="dialogSupply.form.ContactQQ" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="微信：" prop="ContactWechat">
              <el-input size="mini" placeholder="请填写微信" v-model="dialogSupply.form.ContactWechat" class="el-width-200"></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" prop="ContactEmail">
              <el-input size="mini" placeholder="请填写邮箱" v-model="dialogSupply.form.ContactEmail" class="el-width-200"></el-input>
            </el-form-item>
            <div class="clear"></div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="渠道绑定" name="channelbind">
          <el-table :data="dialogSupply.form.ChannelMappingList" :border="true" class="etms-router-list">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column label="渠道" align="center">
              <template slot-scope="scope">
                <el-select size="mini" placeholder="请选择渠道" v-model="scope.row.channelId" filterable clearable class="el-width-200">
                  <el-option v-for="item in channellist" :key="item.id" :value="item.id" :label="item.channelName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="渠道" align="center">
              <template slot-scope="scope">
                <el-input size="mini" placeholder="请填写供应商渠道代码" v-model="scope.row.supplyChannelCode" class="el-width-100"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" width="100px">
              <template slot="header" slot-scope="scope">
                <el-tooltip class="item" content="添加标签" placement="top">
                  <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="insertChannel"></el-button>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-tooltip class="item" content="删除" placement="top">
                  <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteChannel(scope.$index,scope.row)"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="dialogSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    var platformEnterpriseValidate = (rule, value, callback) => {
      if (this.dialogSupply.form.ChannelSupplyType === 1 && value === '') {
        callback('请选择平台物流商')
      }
      callback()
    }
    var channelSupplyNameValidate = (rule, value, callback) => {
      var self = this
      var userinfo = this.$cookies.get('userinfo')
      if (userinfo !== null && userinfo !== undefined) {
        this.$ajax.post(this.constant.openPaths.existsChannelSupplyName, {
          UserId: userinfo.id,
          EnterpriseId: userinfo.enterpriseId,
          LoginToken: userinfo.loginToken,
          ChannelSupplyName: value,
          ChannelSupplyId: self.dialogSupply.form.Id
        }).then(res => {
          switch (res.data.code) {
            case 200:
              callback()
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              callback(res.data.msg)
              break;
          }
        }).catch(error => { callback(error) })
      }
    }

    var channelSupplyCodeValidate = (rule, value, callback) => {
      var self = this
      var userinfo = this.$cookies.get('userinfo')
      if (userinfo !== null && userinfo !== undefined) {
        this.$ajax.post(this.constant.openPaths.existsChannelSupplyCode, {
          UserId: userinfo.id,
          EnterpriseId: userinfo.enterpriseId,
          LoginToken: userinfo.loginToken,
          ChannelSupplyCode: value,
          ChannelSupplyId: self.dialogSupply.form.Id
        }).then(res => {
          switch (res.data.code) {
            case 200:
              callback()
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              callback(res.data.msg)
              break;
          }
        }).catch(error => { callback(error) })
      }
    }
    return {
      userinfo: this.$cookies.get('userinfo'),
      search: {
        pageindex: 1,
        pagesize: 100,
        recordcount: 0,
        SupplyName: '',
        ChannelSupplyType: '',
      },
      supplylist: [],
      channellist: [],
      enterpriselist: [],
      dialogSupply: {
        dialogtitle: '添加供应商',
        dialogvisible: false,
        activename: 'supplyinfo',
        platformshow: false,
        form: {
          formname: 'supplyform',
          Id: '',
          OptimisticLock: '',
          ChannelSupplyType: '',
          ChannelSupplyName: '',
          ChannelSupplyCode: '',
          PlatformEnterpriseId: '',
          ContactName: '',
          ContactRegion: [],
          ContactAddress: '',
          ContactMobile: '',
          ContactPhone: '',
          ContactQQ: '',
          ContactWechat: '',
          ContactEmail: '',
          ChannelMappingList: [],
          rules: {
            ChannelSupplyType: [
              { required: true, message: '请选择分类', trigger: 'change' }
            ],
            PlatformEnterpriseId: [
              { validator: platformEnterpriseValidate, trigger: 'change' }
            ],
            ChannelSupplyName: [
              { required: true, message: '请填写供应商名称', trigger: 'blur' },
              { max: 50, message: '供应商名称不能超过50个字', trigger: 'blur' },
              { validator: channelSupplyNameValidate, trigger: 'blur' }
            ],
            ChannelSupplyCode: [
              { required: true, message: '请填写供应商代码', trigger: 'blur' },
              { max: 10, message: '供应商名称不能超过10个字', trigger: 'blur' },
              { validator: channelSupplyCodeValidate, trigger: 'blur' }
            ],
            ContactRegion: [
              { required: true, message: '请选择地区', trigger: 'change' },
            ],
            ContactName: [
              { max: 30, message: '联系人不可超过30个字', trigger: 'blur' }
            ],
            ContactAddress: [
              { max: 100, message: '详细地址不可超过100个字', trigger: 'blur' }
            ],
            ContactMobile: [
              { max: 20, message: '手机号码不可超过20个字', trigger: 'blur' }
            ],
            ContactPhone: [
              { max: 20, message: '电话号码不可超过20个字', trigger: 'blur' }
            ],
            ContactQQ: [
              { max: 20, message: 'QQ不可超过20个字', trigger: 'blur' }
            ],
            ContactWechat: [
              { max: 20, message: '微信不可超过20个字', trigger: 'blur' }
            ],
            ContactEmail: [
              { max: 30, message: '邮箱不可超过30个字', trigger: 'blur' }
            ]
          }
        }
      }
    }
  },
  mounted () {
    this.initChannelEnterprise()
    this.initChannel()
    this.searchSupplierPager()
  },
  methods: {
    clearForm (form) {
      Object.keys(form).forEach(item => {
        if (item !== 'formname' && item !== 'rules') {
          switch (typeof (form[item])) {
            case 'string':
              form[item] = ''
              break
            case 'number':
              form[item] = ''
              break
            case 'object':
              if (Array.isArray(form[item])) {
                form[item] = []
              } else { }
              break
          }
        }
      })
    },
    initChannelEnterprise () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          BusinessScope: 2
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchEnterpriseList, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.enterpriselist = res.data.result.filter(item => item.id !== data.EnterpriseId)
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    initChannel () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.getChannelList, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.channellist = res.data.result
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    insertSupplier () {
      this.clearForm(this.dialogSupply.form)
      this.dialogSupply.dialogtitle = '添加供应商'
      this.dialogSupply.dialogvisible = true
    },
    searchSupplierPager () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          PageSize: this.search.pagesize,
          PageIndex: this.search.pageindex,
          ChannelSupplyName: this.search.SupplyName,
          ChannelSupplyType: this.search.ChannelSupplyType
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchChannelSupplyPager, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.supplylist = res.data.result.tList
              self.search.recordcount = res.data.result.recordCount
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    handleSizeChange (val) {
      this.pagesize = val
      this.searchSupplierPager()
    },
    handleCurrentChange (val) {
      this.pageindex = val
      this.searchSupplierPager()
    },
    formatterSupplyType (row, column) {
      var channelSupplyType = this.constant.supplyTypes.filter(item => item.value === row.channelSupplyType)[0]
      if (channelSupplyType !== null && channelSupplyType !== undefined) {
        return channelSupplyType.label
      }
      return ''
    },
    formatterRegion (row, column) {
      if (row.contactRegion !== null && row.contactRegion !== undefined && row.contactRegion.length > 0) {
        var region = this.regionmodule.regionEach(row.contactRegion, this.regionmodule.regions, 0)
        return region
      }
      return ''
    },
    supplyTypeChange () {
      if (this.dialogSupply.form.SupplyTypeId === 0) {
        this.dialogSupply.platformshow = true
      } else {
        this.dialogSupply.platformshow = false
      }
    },
    dialogSave () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          Id: this.dialogSupply.form.Id,
          OptimisticLock: this.dialogSupply.form.OptimisticLock,
          ChannelSupplyType: this.dialogSupply.form.ChannelSupplyType,
          ChannelSupplyCode: this.dialogSupply.form.ChannelSupplyCode,
          ChannelSupplyName: this.dialogSupply.form.ChannelSupplyName,
          PlatformEnterpriseId: this.dialogSupply.form.PlatformEnterpriseId,
          ContactName: this.dialogSupply.form.ContactName,
          ContactRegion: this.dialogSupply.form.ContactRegion,
          ContactAddress: this.dialogSupply.form.ContactAddress,
          ContactMobile: this.dialogSupply.form.ContactMobile,
          ContactPhone: this.dialogSupply.form.ContactPhone,
          ContactQQ: this.dialogSupply.form.ContactQQ,
          ContactWechat: this.dialogSupply.form.ContactWechat,
          ContactEmail: this.dialogSupply.form.ContactEmail,
          ChannelMappingList: this.dialogSupply.form.ChannelMappingList
        }
        var url = this.constant.openPaths.insertChannelSupply
        if (data.Id !== '' && data.OptimisticLock !== '') {
          url = this.constant.openPaths.updateChannelSupply
        }

        var self = this
        this.$refs[this.dialogSupply.form.formname].validate((valid) => {
          if (valid) {
            self.$ajax.post(url, data).then(res => {
              switch (res.data.code) {
                case 200:
                  self.$message({ message: res.data.msg, type: 'success' })
                  self.clearForm(self.dialogSupply.form)
                  self.searchSupplierPager()
                  self.dialogSupply.dialogvisible = false
                  break;
                case 402:
                  self.$router.push({ name: 'login' })
                  break
                default:
                  self.$message.error(res.data.msg)
                  break;
              }
            })
          }
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    editChannelSupply (row) {
      this.clearForm(this.dialogSupply.form)
      this.dialogSupply.form.Id = row.id
      this.dialogSupply.form.OptimisticLock = row.optimisticLock
      this.dialogSupply.form.ChannelSupplyType = row.channelSupplyType
      this.dialogSupply.form.PlatformEnterpriseId = row.platformEnterpriseId
      this.dialogSupply.form.ChannelSupplyCode = row.channelSupplyCode
      this.dialogSupply.form.ChannelSupplyName = row.channelSupplyName
      this.dialogSupply.form.ContactName = row.contactName
      this.dialogSupply.form.ContactRegion = row.contactRegion
      this.dialogSupply.form.ContactAddress = row.contactAddress
      this.dialogSupply.form.ContactMobile = row.contactMobile
      this.dialogSupply.form.ContactPhone = row.contactPhone
      this.dialogSupply.form.ContactQQ = row.contactQQ
      this.dialogSupply.form.ContactWechat = row.contactWechat
      this.dialogSupply.form.ContactEmail = row.contactEmail
      this.dialogSupply.form.ChannelMappingList = row.channelMappingList
      this.dialogSupply.dialogtitle = '修改供应商'
      this.dialogSupply.dialogvisible = true
    },
    removeChannelSupply (row) {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          Id: this.dialogSupply.form.Id,
          OptimisticLock: this.dialogSupply.form.OptimisticLock
        }

        var self = this
        this.$confirm('此操作将删除供应商,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.$ajax.post(this.constant.openPaths.deleteChannelSupply, data).then(res => {
            switch (res.data.code) {
              case 200:
                self.$message({ message: res.data.msg, type: 'success' })
                self.searchSupplierPager()
                break;
              case 402:
                self.$router.push({ name: 'login' })
                break
              default:
                self.$message.error(res.data.msg)
                break;
            }
          }).catch(error => { self.$message.error(error) })
        })
      }

    },
    insertChannel () {
      this.dialogSupply.form.ChannelMappingList.push({ channelId: '', supplyChannelCode: '' })
    },
    deleteChannel (index, row) {
      this.dialogSupply.form.ChannelMappingList.splice(index, 1)
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/supplier_manage.vue